import { queryOptions, useQuery } from '@tanstack/react-query';

import { NodeSelectionTemplateWithClusterId } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const CLUSTERS_NODE_TEMPLATES_QUERY_KEY = 'clusters-node-templates';

export const getClustersNodeTemplatesQueryKey = (clusterIds?: string[]) =>
  clusterIds
    ? ([CLUSTERS_NODE_TEMPLATES_QUERY_KEY, clusterIds] as const)
    : ([CLUSTERS_NODE_TEMPLATES_QUERY_KEY] as const);

const fetchClustersNodeTemplates = async (
  clusterIds: string[]
): Promise<NodeSelectionTemplateWithClusterId[]> => {
  return Promise.all(
    clusterIds.map((clusterId) => {
      return apiClient.autoscaler
        .getSelectionTemplates({
          clusterId,
          includeDefault: true,
        })
        .then((response) => {
          return (response.data.items || []).map((item) => ({
            ...item.template,
            clusterId,
          }));
        });
    })
  ).then((responses) => responses.flat());
};

const getClustersNodeTemplatesQueryOptions = (
  clusterIds: string[],
  enabled?: boolean
) =>
  queryOptions({
    queryKey: getClustersNodeTemplatesQueryKey(clusterIds),
    queryFn: async () => fetchClustersNodeTemplates(clusterIds),
    enabled,
  });

type UseClustersNodeTemplatesQueryArgs = {
  clusterIds: string[];
  enabled?: boolean;
};

export const useClustersNodeTemplatesQuery = ({
  clusterIds,
  enabled,
}: UseClustersNodeTemplatesQueryArgs) => {
  return useQuery(getClustersNodeTemplatesQueryOptions(clusterIds, enabled));
};
